import React from 'react';
import { AddIcon } from 'cokitchen-icons';
import '../../events/event-details/styles.scss';
import { DepartmentType, MemberType } from './types';
import AddMemberForm from './add-member-form';
import { defaultData } from './util';

const AddMember = ({
  members,
  setMembers,
  departmentOptions,
  active
}: {
  members: MemberType[];
  setMembers: (members: MemberType[]) => void;
  departmentOptions: DepartmentType[];
  active: string;
}) => {
  const updateMemberData = (index: number, newMember: MemberType) =>
    setMembers(
      members.map((member, i) => {
        if (i === index) return newMember;
        return member;
      })
    );
  const handleMemberDelete = (indexToDelete: number) => {
    setMembers(members.filter((_, i) => i !== indexToDelete));
  };
  const getDepartment = (departmentName: string | undefined) => {
    const dptObject = departmentOptions.find((dpt: DepartmentType) => {
      return dpt.name === departmentName;
    });
    return dptObject;
  };
  return (
    <div>
      <div>
        {members.map((member, index) => (
          <AddMemberForm
            key={index}
            memberData={member}
            handleDelete={() => handleMemberDelete(index)}
            setMemberData={(newMember) => updateMemberData(index, newMember)}
            showRemoveButton={index !== 0}
            departmentOptions={departmentOptions}
            dpt={getDepartment(member.department_name)}
          />
        ))}
      </div>
      {active === 'manual' && (
        <div
          className='text-[#0080E5] flex items-center gap-[2px] text-sm font-medium cursor-pointer my-4'
          onClick={() => setMembers([...members, defaultData])}>
          <AddIcon className='w-5 h-5' />
          <span>Add Member</span>
        </div>
      )}
    </div>
  );
};

export default AddMember;
